import { React } from "mondrian-react";

const Alert = ({ text, onClose }) => {
  return (
    <div
      onAnimationEnd={onClose}
      className={
        "fatura-facil-alert mdn-Container"
      }
    >
      <div className="mdn-Alert mdn-Alert--success mdn-Alert--light mdn-isOpen">
        <div className="mdn-Alert-content">
          <p className="mdn-Text mdn-Text--body">{text}</p>
        </div>
      </div>
    </div>
  );
};
export default Alert;
